import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';

import { IdentityConfigurationService } from '@auth';
import { getClientUrl } from '@core';

interface ModuleSearchConfig {
    modulePath: string;
    resultsPath: string;
}

const MODULE_SEARCH_CONFIG: Readonly<Record<string, ModuleSearchConfig>> = {
    PA: { modulePath: 'planning',        resultsPath: 'search-applications/results' },
    BR: { modulePath: 'buildingcontrol', resultsPath: 'search-applications/results' },
    EN: { modulePath: 'enforcements',    resultsPath: 'search-enforcements/results' },
    TP: { modulePath: 'tpo',             resultsPath: 'search/results' },
};

@Injectable({
    providedIn: 'root'
})
export class HeaderSearchService {
    private readonly router = inject(Router);
    private readonly identityConfigurationService = inject(IdentityConfigurationService);

    readonly searchQuery = signal('');

    performSearch(query: string): void {
        const trimmed = query.trim();
        if (!trimmed) return;

        const serviceCode = this.identityConfigurationService.getService();
        const config = MODULE_SEARCH_CONFIG[serviceCode];
        if (!config) return;

        const clientUrl = getClientUrl();
        this.router.navigate(
            [`/${clientUrl}/${config.modulePath}/${config.resultsPath}`],
            { queryParams: { reference: trimmed } }
        );
    }

    isAvailable(): boolean {
        const serviceCode = this.identityConfigurationService.getService();
        return serviceCode in MODULE_SEARCH_CONFIG;
    }

    clearQuery(): void {
        this.searchQuery.set('');
    }
}
